import { createNewThreadRpc, getLatestThreadAndInteractionOrCreateNewRpc, getThreadMetadataRpc, getThreadWithInteractionsRpc, getThreadsRpc, mergeThreadWithLatestThreadRpc, softDeleteThreadRpc, getBoxIdFromThreadRpc } from '../../../__generated__/chirp/com/hubspot/copilot/rpc/CopilotThreadsService';
import { rpcClient } from '../../http/rpcClient';
export const createNewThread = assistantType => {
  return rpcClient.call(createNewThreadRpc, {
    request: {
      assistantType
    }
  });
};
export const getLatestOrNewThread = (threadId, latestActivityTimestamp) => {
  return rpcClient.call(getLatestThreadAndInteractionOrCreateNewRpc, {
    request: {
      threadId,
      latestActivityTimestamp
    }
  });
};
export const getThreadMetadata = threadId => {
  return rpcClient.call(getThreadMetadataRpc, {
    request: {
      threadId
    }
  });
};
export const getThreads = ({
  mostRecentlyUsedAtOffset,
  limit,
  shouldIncludePreviews
}) => {
  return rpcClient.call(getThreadsRpc, {
    request: {
      mostRecentlyUsedAtOffset,
      limit,
      shouldIncludePreviews
    }
  });
};
export const getThreadWithInteractions = ({
  threadId,
  interactionOffset,
  interactionLimit
}) => {
  return rpcClient.call(getThreadWithInteractionsRpc, {
    request: {
      threadId,
      interactionOffset,
      interactionLimit
    }
  });
};
export const mergeThreadWithLatestThread = threadId => {
  return rpcClient.call(mergeThreadWithLatestThreadRpc, {
    request: {
      threadId
    }
  });
};
export const softDeleteThread = threadId => {
  return rpcClient.call(softDeleteThreadRpc, {
    request: {
      threadId
    }
  });
};
export const getBoxIdFromThreadId = threadId => {
  return rpcClient.call(getBoxIdFromThreadRpc, {
    request: {
      threadId
    }
  });
};